import styled from "styled-components";
import { useTranslation } from 'react-i18next';

type Props = {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
};

const TabContainer = styled.div`
  display: flex;
  gap: 1em;
  padding: 0 1em;
  border-bottom:  1px solid #373956;
  margin-top: .4em;

  @media (max-width: 768px) {
    justify-content: space-around;
  }
`

const TabButton = styled.button<{ $active: boolean }>`
  position: relative;
  max-height: 37px;
  min-height: 37px;
  padding-bottom: 0.5rem;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ $active }) => ($active ? "#3C4043" : "#878B8E")};
  font-weight: 600;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -1px;
    height: 4px;
    width: 100%;
    background: ${({ $active }) =>
      $active
        ? "linear-gradient(318deg, #00B2B5 16.44%, #96FFD2 85.22%)"
        : "transparent"};
    transform: ${({ $active }) => ($active ? "scale(1)" : "scale(0)")};
    transition: all 250ms ease;
  }
`;
  
export default function Tabs({ selectedTab, setSelectedTab }: Props) {
  const { t } = useTranslation('settings');
  const tabs = [
    { key: "organization", label: t('tabs.organization') },
    { key: "users", label: t('tabs.users') },
    { key: "groups", label: t('tabs.groups') },
  ];

  return (
    <TabContainer>
      {tabs.map(({ key, label }) => (
        <TabButton
          key={key}
          $active={selectedTab === key}
          onClick={() => setSelectedTab(key)}
        >
          {label}
        </TabButton>
      ))}
    </TabContainer>
  );
}
